import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { NO_DISPATCHED_ORDER_MESSAGE } from "../../types/order";

function DashboardNoOrdersMessage({
  title = "",
  body = NO_DISPATCHED_ORDER_MESSAGE,
  icon,
}) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{
        textAlign: "center",
        padding: 4,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "6px",
        backgroundColor: grey["50"],
      }}
    >
      <Box>{icon}</Box>
      <Typography variant="h5" component="h5">
        {title}
      </Typography>
      <Typography variant="body1" component="p" color="textSecondary">
        {body}
      </Typography>
    </Stack>
  );
}

export default DashboardNoOrdersMessage;
